import type { ButtonCopyProps } from "./button-copy.type";

import { CopyOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";

const ButtonCopy = ({ data, buttonText }: ButtonCopyProps) => {
  const { t } = useTranslation();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(data);
      message.success(t("global:copyButton.success"));
    } catch (err) {
      console.error(t("global:copyButton.error"), err);
      message.error(t("global:copyButton.error"));
    }
  };

  return (
    <Button icon={<CopyOutlined />} onClick={handleCopy}>
      {buttonText ?? t("global:copyButton.label")}
    </Button>
  );
};

export default ButtonCopy;
